import { AccountPage as TokenClientAccountPage } from '@codespeak11/token-client/react';
import { useNavigate } from 'react-router-dom';
import { useAuth } from '@codespeak11/cognito-passwordless';

export default function SettingsPage() {
  const { getValidToken } = useAuth();
  const navigate = useNavigate();

  return (
    <TokenClientAccountPage
      getAccessToken={getValidToken}
      pageTitle="Settings"
      pricingUrl="https://braindance.net/pricing"
      onSessionExpired={() => navigate('/login', { replace: true })}
    />
  );
}
